module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg3@3x.c786ae4a.png";